<template>
    <div class="top-stats">
        <tapered-rule></tapered-rule>
        <slot></slot>
        <tapered-rule></tapered-rule>
    </div>
</template>

<script>
import taperedRule from './taperedRule.vue';
export default {
    name: 'property-line',
    props: {
        header:String,
        text: String
    },
    components:{
        'tapered-rule':taperedRule
    }
}
</script>

<style scope>
    .top-stats{
    color: #7A200D;
    }
</style>